var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScaleway(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#4f0599"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.2 493v122c-.7 18.4-14.6 33.7-32.9 36.1H492c-14.3-1.1-25.9-11.9-27.9-26-.1-1.3-.1-2.6 0-3.8.1-16.1 13.2-29 29.2-29h37.1c11.8 0 21.3-9.6 21.3-21.3v-77.2c-.1-14.7 10.6-27.3 25.2-29.7h3.6c16.1-.2 29.4 12.7 29.7 28.8v.1zm-137.8 37.1v-76.6c0-11.8 9.6-21.3 21.3-21.3h39.5c16.1 0 29.2-13.1 29.2-29.2.1-1.2.1-2.4 0-3.6-2.6-14.7-15.2-25.4-30.1-25.6h-84.5c-18.2 2.3-32.3 17.1-33.7 35.4v121.6c0 16.1 13.1 29.2 29.2 29.2h4.5c14.5-2.6 24.9-15.2 24.6-29.9zm256-91.5v244c-5.3 46-42.4 81.8-88.5 85.3H478.2c-100.9-.1-182.6-81.9-182.6-182.8V352.9c0-53.5 43.4-96.9 96.9-96.9h153.2c100.9 0 182.6 81.8 182.6 182.6h.1zm-58.4 0c-.1-68.5-55.6-124-124.2-124.2H392.4c-21.1-.1-38.3 16.9-38.4 38v232.7c.4 68.4 55.8 123.6 124.2 123.7h158.7c16.7-2.1 30.1-15 32.9-31.6l.2-238.6z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleway);
export default __webpack_public_path__ + "static/media/scaleway.5aa156926defa0bf4577d851a98df56f.svg";
export { ForwardRef as ReactComponent };